export default __webpack_public_path__ + "static/media/gm-isb-girl.a4b3140f.webp";